import { SignUpModes } from '../../constants';
import { reportApiError } from '../../errors';
import { adrollApi } from '../../services/adroll';
import { ActionMap, IField } from '../../typings';
import {
    ISetFetchErrorPayload,
    ISetFetchInProgressPayload,
    ISetFetchSuccessPayload,
    setFetchError,
    setFetchInProgress,
    setFetchSuccess,
} from '../common';
import { ISetFieldPayload } from '../sign-up/SignUpActions';

// Definitions

export enum ACTION_TYPES {
    EMAIL_VERIFICATION_SET_MODE = 'EMAIL_VERIFICATION_SET_MODE',
    EMAIL_VERIFICATION_UPDATE_EMAIL_FIELD = 'EMAIL_VERIFICATION_UPDATE_EMAIL_FIELD',
    CHANGE_EMAIL_SUBMIT_IN_PROGRESS = 'CHANGE_EMAIL_SUBMIT_IN_PROGRESS',
    CHANGE_EMAIL_SUBMIT_SUCCESS = 'CHANGE_EMAIL_SUBMIT_SUCCESS',
    CHANGE_EMAIL_SUBMIT_ERROR = 'CHANGE_EMAIL_SUBMIT_ERROR',
    FETCH_STATUS_SUBMIT_IN_PROGRESS = 'FETCH_STATUS_SUBMIT_IN_PROGRESS',
    FETCH_STATUS_SUBMIT_SUCCESS = 'FETCH_STATUS_SUBMIT_SUCCESS',
    FETCH_STATUS_SUBMIT_ERROR = 'FETCH_STATUS_SUBMIT_ERROR',
}

export interface ISetModePayload {
    mode: SignUpModes;
}

export interface IFetchStatusSuccessPayload {
    bu: string;
    eid: string;
    email: string;
    status: string;
}

type EmailVerificationPayloads = {
    [ACTION_TYPES.EMAIL_VERIFICATION_SET_MODE]: ISetModePayload;
    [ACTION_TYPES.EMAIL_VERIFICATION_UPDATE_EMAIL_FIELD]: Partial<ISetFieldPayload>;
    [ACTION_TYPES.CHANGE_EMAIL_SUBMIT_IN_PROGRESS]: ISetFetchInProgressPayload;
    [ACTION_TYPES.CHANGE_EMAIL_SUBMIT_SUCCESS]: ISetFetchSuccessPayload;
    [ACTION_TYPES.CHANGE_EMAIL_SUBMIT_ERROR]: ISetFetchErrorPayload;
    [ACTION_TYPES.FETCH_STATUS_SUBMIT_IN_PROGRESS]: ISetFetchInProgressPayload;
    [ACTION_TYPES.FETCH_STATUS_SUBMIT_SUCCESS]: IFetchStatusSuccessPayload;
    [ACTION_TYPES.FETCH_STATUS_SUBMIT_ERROR]: ISetFetchErrorPayload;
};

export type EmailVerificationActions =
    ActionMap<EmailVerificationPayloads>[keyof ActionMap<EmailVerificationPayloads>];

export const updateEmailFieldFactory =
    (dispatchFn: React.Dispatch<EmailVerificationActions>) =>
    (patch: Partial<IField<string>>) => {
        dispatchFn({
            type: ACTION_TYPES.EMAIL_VERIFICATION_UPDATE_EMAIL_FIELD,
            payload: { fieldName: 'emailField', data: patch },
        });
    };

export const fetchEVStatusFactory =
    (dispatchFn: React.Dispatch<EmailVerificationActions>) =>
    async (urlStatus: string | null) => {
        try {
            dispatchFn(
                setFetchInProgress(ACTION_TYPES.FETCH_STATUS_SUBMIT_IN_PROGRESS)
            );

            const res = await adrollApi.get(
                '/api/v1/email_verification/status'
            );

            if (urlStatus) {
                res.status = urlStatus;
            }

            dispatchFn({
                type: ACTION_TYPES.FETCH_STATUS_SUBMIT_SUCCESS,
                payload: res,
            });
        } catch (error) {
            reportApiError(error);
            dispatchFn(
                setFetchError(ACTION_TYPES.FETCH_STATUS_SUBMIT_ERROR, error)
            );
        }
    };

export const changeEmailFactory =
    (dispatchFn: React.Dispatch<EmailVerificationActions>, email: string) =>
    async () => {
        try {
            dispatchFn(
                setFetchInProgress(ACTION_TYPES.CHANGE_EMAIL_SUBMIT_IN_PROGRESS)
            );

            await adrollApi.post(
                '/api/v1/email_verification/edit_email_address',
                {},
                { email }
            );

            dispatchFn(
                setFetchSuccess(ACTION_TYPES.CHANGE_EMAIL_SUBMIT_SUCCESS)
            );
        } catch (error) {
            reportApiError(error);
            dispatchFn(
                setFetchError(ACTION_TYPES.CHANGE_EMAIL_SUBMIT_ERROR, error)
            );
        }
    };
